import { CARD_TYPE_MAP } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';

export const PAPER_ADD_ON_FILTER_TYPES_MAP = new Map([
  ['belly-bands', CARD_TYPE_MAP.bellyBand],
  ['vellum-jackets', CARD_TYPE_MAP.vellumJacket],
  ['wax-seals', CARD_TYPE_MAP.waxSeal],
]);
